var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_100",
    "data-name": "Grupo 100",
    transform: "translate(-240 -2617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_237",
    "data-name": "Ret\\xE2ngulo 237",
    transform: "translate(240 2617)",
    fill: "none",
    stroke: "#81d742",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 46.5,
    height: 46.5,
    rx: 4.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_142",
    "data-name": "Caminho 142",
    d: "M282.19,159.266l.567.652,6.052,7.06,1.523-1.3-5.495-6.409,5.495-6.409-1.523-1.3-6.052,7.06-.567.652Z",
    transform: "translate(-22.261 2481.734)",
    fill: "#81d742"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevArrow);
export default __webpack_public_path__ + "static/media/prevArrow.f30a0a6e14f54fe2a618a3403cb91d38.svg";
export { ForwardRef as ReactComponent };